import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import EnquiryEntriesRepository from "@/utilities/repositories/EnquiryEntries";
import { IEnquiryEntry } from "@/utilities/types/EnquiryEntry";
import LeadDetailsPanel from "@/app/app-shared/enquiry-entrties/desktop/LeadDetailsPanel";
import { Loader, Text, Button } from "rizzui";
import { Fragment } from "react/jsx-runtime";
import { routes } from "@/config/routes";
import { publicRoutesType } from "@/types/routes";
import { PiUserCircleLight } from "react-icons/pi";

function PublicLeadDetailsPageContent() {
  const { token } = useParams<{ token: string }>();
  const [lead, setLead] = useState<IEnquiryEntry | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const handleAgentLogin = () => {
    window.open(routes.contacts.listing, "_blank");
  };

  useEffect(() => {
    if (token) {
      EnquiryEntriesRepository.getByToken(token)
        .then((res) => {
          setLead(res.data.items?.[0] || null);
        })
        .catch((err) => {
          console.error("Error fetching lead by token:", err);
          setError("Lead not found or link expired.");
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setError("Invalid token provided.");
      setLoading(false);
    }
  }, [token]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader />
      </div>
    );
  }

  if (error || !lead) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Text>{error || "Lead not found"}</Text>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto h-[100dvh] bg-white shadow-lg overflow-hidden pt-[env(safe-area-inset-top)] md:h-screen md:my-20 md:rounded-lg relative">
      {/* Agent Login Button - Prominently displayed but not disruptive */}
      <div className="fixed top-2 right-2 md:top-4 md:right-4 z-50">
        <Button
          variant="text"
          size="lg"
          onClick={handleAgentLogin}
          className="flex items-center gap-2  md:!text-white shadow-lg hover:shadow-xl transition-shadow duration-200 bg-white md:bg-black border  border-black md:border-0"
        >
          <PiUserCircleLight className="w-5 h-5 hidden md:inline" />
          <span className="font-medium hidden md:inline">Agent Login</span>
          <span className="font-medium md:hidden">Login</span>
        </Button>
      </div>
      <LeadDetailsPanel
        token={token}
        selectedLead={lead}
        isReadOnly={true} // Ensure it's read-only
        onRefresh={() => {}} // No refresh needed for read-only view
      />
    </div>
  );
}

export const PublicLeadDetailsPage: publicRoutesType = {
  path: routes.contacts.publicLeadDetails(":token"),
  component: PublicLeadDetailsPageContent,
  layout: Fragment,
};
